import FormBase from "../FormBase";
import FormFieldAttachmentBase from "../../forms/FormFieldAttachmentBase";
import ValidationBase, { ValidationType } from "../../forms/ValidationBase";

export enum EAttachmentSpecialAuthorization {
    CartaAutorizacaoAssinada = 27,
    CarteiraProfissionalClasse = 28,
    CertificadoAtuacaoInstrumentacao = 29,
    CPFeRG = 30,
    TituloEspecialista = 31,
    RelatorioMedico = 60,
    CertidaoEticaProfissional = 68,
}

export default class AttachmentForm implements FormBase {

    CartaAutorizacaoAssinada: FormFieldAttachmentBase;
    CarteiraProfissionalClasse: FormFieldAttachmentBase;
    CertificadoAtuacaoInstrumentacao: FormFieldAttachmentBase;
    CPFeRG: FormFieldAttachmentBase;
    TituloEspecialista: FormFieldAttachmentBase;
    RelatorioMedico: FormFieldAttachmentBase;
    CertidaoEticaProfissional: FormFieldAttachmentBase;


    constructor() {
        this.CartaAutorizacaoAssinada = new FormFieldAttachmentBase([], 2, [], EAttachmentSpecialAuthorization.CartaAutorizacaoAssinada);
        this.CarteiraProfissionalClasse = new FormFieldAttachmentBase([], 1, [new ValidationBase("", ValidationType.ANEXO_OBRIGATORIO)], EAttachmentSpecialAuthorization.CarteiraProfissionalClasse);
        this.CertificadoAtuacaoInstrumentacao = new FormFieldAttachmentBase([], 1, [], EAttachmentSpecialAuthorization.CertificadoAtuacaoInstrumentacao);
        this.CPFeRG = new FormFieldAttachmentBase([], 1, [], EAttachmentSpecialAuthorization.CPFeRG);
        this.TituloEspecialista = new FormFieldAttachmentBase([], 1, [new ValidationBase("", ValidationType.ANEXO_OBRIGATORIO)], EAttachmentSpecialAuthorization.TituloEspecialista);
        this.RelatorioMedico = new FormFieldAttachmentBase([], 1, [new ValidationBase("", ValidationType.CUSTOM)], EAttachmentSpecialAuthorization.RelatorioMedico, ((value: any, state: any) => { return this.ValidateIfAttachmentIsMandatory(value, state) }));
        this.CertidaoEticaProfissional = new FormFieldAttachmentBase([], 1, [new ValidationBase("", ValidationType.CUSTOM)], EAttachmentSpecialAuthorization.CertidaoEticaProfissional, ((value: any, state: any) => { return this.ValidateIfAttachmentEticalIsMandatory(value, state) }));
    }

    static NewInstance(): AttachmentForm {
        return new AttachmentForm();
    }

    CallInsertOrUpdateApi(): Promise<boolean> {
        return Promise.resolve(true);
    }

    ValidateIfAttachmentIsMandatory(value: any, state: any): string {
        
        if(state !== null && state !== undefined && state.ParticipationRequestForm.RequestParticipate.Value === "MedicoPrincipal")
        {
            if(value == null || value.length === 0 )
            {
                return "O anexo é obrigatório."
            }
        }

        return "";
    }

    ValidateIfAttachmentEticalIsMandatory(value: any, state: any): string {
     
        if(state !== null && state !== undefined && (state.ParticipationRequestForm.RequestParticipate.Value === "MedicoPrincipal" || state.ParticipationRequestForm.RequestParticipate.Value === "MedicoAuxiliar"))
        {
            if(value == null || value.length === 0 )
            {
                return "O anexo é obrigatório."
            }
        }

        return "";
    }

    ValidateToGoNextStep(state?: any): string {
        let propNames = Object.getOwnPropertyNames(this);

        let formIsValid = true;
        let maxLengthIsValid = true;

        for (let index = 0; index < propNames.length; index++) {
            const element = propNames[index];

            const error = this.GetFieldByName(element).ValidateField(state);

            if (error !== null && error !== "") {
                formIsValid = false;
            }

            if(element !== null) {

                let files = this.GetFieldByName(element).Values;

                for (let indexFile = 0; indexFile < files.length; indexFile++) {
                    const file = files[indexFile];

                    if (file.ErrorMessage !== null && file.ErrorMessage !== "") {
                        formIsValid = false;
                        maxLengthIsValid = false;
                    }
                }
            }
        }

        if (!formIsValid) {
            if(!maxLengthIsValid){
                return "O tamanho do arquivo é maior do que o permitido, impossibilitando avançar. Favor remover e inserir arquivo do tamanho de até 3MB."
            }else{
                return "Por favor, insira os anexos obrigatórios."
            }
        } else {
            return "";
        }
    }


    GetFieldByName(name: string): FormFieldAttachmentBase {
        switch (name) {

            case "CartaAutorizacaoAssinada":
                return this.CartaAutorizacaoAssinada

            case "CarteiraProfissionalClasse":
                return this.CarteiraProfissionalClasse

            case "CertificadoAtuacaoInstrumentacao":
                return this.CertificadoAtuacaoInstrumentacao

            case "TituloEspecialista":
                return this.TituloEspecialista

            case "CPFeRG":
                return this.CPFeRG

            case "RelatorioMedico":
                return this.RelatorioMedico

            case "CertidaoEticaProfissional":
                return this.CertidaoEticaProfissional

            default:
                return new FormFieldAttachmentBase([], 0, []);
        }
    }
};
